import { createContext, useContext, useMemo, type ReactNode } from "react";
import { config } from "../config";
import { useAuth } from "../auth/AuthContext";
import { createHttpApi } from "./http";
import { createMockApi } from "../mocks/mockApi";
import type { PortalApi } from "./types";

const ApiContext = createContext<PortalApi | null>(null);

type Props = {
  children: ReactNode;
  // Injeção para testes; em runtime a escolha vem de VITE_USE_MOCK_API.
  api?: PortalApi;
};

export function ApiProvider({ children, api }: Props) {
  const auth = useAuth();
  const value = useMemo<PortalApi>(() => {
    if (api) return api;
    if (config.useMockApi) return createMockApi();
    return createHttpApi({
      baseUrl: config.apiUrl,
      getToken: auth.getAccessToken,
      // A tela informa a sessão inválida. Reiniciar o redirect automaticamente
      // aqui criaria um loop caso o backend rejeitasse o token.
      onUnauthorized: () => undefined,
    });
  }, [api, auth.getAccessToken]);

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export function usePortalApi(): PortalApi {
  const value = useContext(ApiContext);
  if (!value) throw new Error("usePortalApi precisa estar dentro de um ApiProvider.");
  return value;
}
